import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useHasApiAccess = (): {
  hasApiAccess: boolean;
  hasMultisiteApiAccess: boolean;
  hasVodApiAccess: boolean;
  hasWebApiAccess: boolean;
} => {
  const { customer: customerInfo } = useCustomer();
  const vodPlan = customerInfo?.vodPlan;
  const webPlan = customerInfo?.webPlan;
  const multisitePlan = customerInfo?.multisitePlan;
  const hasVodApiAccess = Boolean(vodPlan && vodPlan.apiRequestsPerMinute > 0);
  const hasWebApiAccess = Boolean(webPlan && webPlan.apiRequestsPerMinute > 0);
  const hasMultisiteApiAccess = Boolean(multisitePlan && multisitePlan.apiRequestsPerMinute > 0);
  return {
    hasApiAccess: hasVodApiAccess || hasWebApiAccess || hasMultisiteApiAccess,
    hasVodApiAccess,
    hasWebApiAccess,
    hasMultisiteApiAccess,
  };
};

export default useHasApiAccess;
